$(document).ready(function () {
    var x_countDown;

    $('#forgetPassword #email').keyup(function (e) {
        if (this.value.length > 1) {
            $('#forgetPassword #btnForgetPassword').addClass('btn-active');
        } else {
            $('#forgetPassword #btnForgetPassword').removeClass('btn-active');
        }
    });

    $('#forgetPassword').on('click', '#btnForgetPassword', function () {
        var item = $(this);
        var old_curent = item.html();
        item.html('<i class="fa fa-spinner fa-spin"></i>' + old_curent);
        item.prop('disabled', true);

        var email = $('#forgetPassword input[name=email]').val();

        $.ajax({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            url: '/forget-password',
            type: 'POST',
            dataType: 'json',
            data: {
                email: email
            },
            success: function (result) {
                item.html(old_curent);
                item.prop('disabled', false);

                if (result.success == true) {
                    if (result.redirect) {
                        window.location = result.redirect;
                    }

                    let email_html = email.slice(0, 3) + '*****' + email.slice(-5);

                    $('#confirmOTP input[name=username__c]').val(email);
                    $('#confirmOTP input[name=contact_sfid]').val(result.data.contact_id);

                    $('#confirmOTP').removeClass('d-none');
                    $('#confirmOTP').addClass('d-block');

                    $('#confirmOTP .username__c').html(email_html);
                    $('#confirmOTP #n0').focus();

                    var time_active_otp = result.data.time_active_otp;
                    countDown(time_active_otp);

                    $('#forgetPassword .message_error').html('');
                    $('#forgetPassword input[name=email]').val('');

                    $('#forgetPassword').removeClass('d-block');
                    $('#forgetPassword').addClass('d-none');
                } else {
                    $('#forgetPassword .message_error').html('Email không đúng');
                }
            },
            error: function () {

            },
        });
    });

    $('#confirmOTP .list_input_otp').find('.input-otp').each(function () {
        $(this).on('keyup', function (e) {
            if (e.keyCode === 8 || e.keyCode === 37) {
                let previous = $(this).data('previous');
                $('#n' + previous).focus();

                $('#confirmOTP #btnConfirmOTP').removeClass('btn-active');
            } else {
                if (this.value.length === this.maxLength) {
                    let next = $(this).data('next');
                    $('#n' + next).focus();

                    if (next == 6) {
                        $('#confirmOTP #btnConfirmOTP').addClass('btn-active');
                        $('#confirmOTP #btnConfirmOTP').prop('disabled', false);
                    } else {
                        $('#confirmOTP #btnConfirmOTP').removeClass('btn-active');
                        $('#confirmOTP #btnConfirmOTP').prop('disabled', true);
                    }
                }
            }
        });
    });

    $('#confirmOTP').on('click', '#btnConfirmOTP', function () {
        var item = $(this);
        var old_curent = item.html();
        item.html('<i class="fa fa-spinner fa-spin"></i> ' + old_curent);
        item.prop('disabled', true);

        var otp = $("#confirmOTP input[name^='otp']").map(function (idx, ele) {
            return $(ele).val();
        }).get();

        var username__c = $('#confirmOTP input[name=username__c]').val();

        $.ajax({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            url: '/confirm-otp',
            type: 'POST',
            dataType: 'json',
            data: {
                otp: otp,
                phone: username__c
            },
            success: function (result) {
                item.html(old_curent);
                item.prop('disabled', false);

                if (result.success == true) {
                    $('#confirmOTP input[name=contact_sfid]').val('');
                    $('#confirmOTP input[name=username__c]').val('');
                    $('#confirmOTP input[name=otp\\[\\]]').val('');
                    $('#confirmOTP .message_error').html('');

                    $('#confirmOTP').removeClass('d-block');
                    $('#confirmOTP').addClass('d-none');

                    $('#changePassOTP input[name=contact_sfid]').val(result.data.contact_id);

                    $('#changePassOTP').removeClass('d-none');
                    $('#changePassOTP').addClass('d-block');
                } else {
                    $('#confirmOTP .message_error').html(result.message);
                }
            },
            error: function () {

            },
        });
    });

    $('#confirmOTP').on('click', '#sentAgainOTP', function () {
        var item = $(this);
        var old_curent = item.html();
        item.html('<i class="fa fa-spinner fa-spin"></i> ' + old_curent);
        item.prop('disabled', true);

        var contact_sfid = $('#confirmOTP input[name=contact_sfid]').val();
        $.ajax({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            url: '/send-otp',
            type: 'POST',
            dataType: 'json',
            data: {
                contact_sfid: contact_sfid,
            },
            success: function (result) {
                item.html(old_curent);
                item.prop('disabled', false);

                var time_active_otp = result.data.time_active_otp;
                countDown(time_active_otp);
            },
            error: function () {
            },
        });
    });

    $('#confirmOTP .back').on('click', function(){
        $('#forgetPassword').removeClass('d-none');
        $('#forgetPassword').addClass('d-block');

        $('#confirmOTP').removeClass('d-block');
        $('#confirmOTP').addClass('d-none');

        clearInterval(x_countDown);
        $('#confirmOTP #countDownOTP').find('.seconds').html('');
        $('#confirmOTP input[name=otp\\[\\]]').val('');
    });

    $('#changePassOTP .item-eye-off').on('click', function () {
        if ($(this).find('.eye-off').attr("src") == '/image/eye.svg') {
            $(this).find('.eye-off').attr("src", "/image/eye-off.svg");
            $(this).closest('.form-group').find('.show_pass').prop('type', 'password');
        } else {
            $(this).find('.eye-off').attr("src", "/image/eye.svg");
            $(this).closest('.form-group').find('.show_pass').prop('type', 'text');
        }
    });
    $('#changePassOTP #password_new').keyup(function () {
        var password_new = $('#changePassOTP #password_new').val();
        var password_new_confirmation = $('#changePassOTP #password_new_confirmation').val();

        if (password_new.length > 0 && password_new_confirmation.length > 0) {
            $('#changePassOTP #btnChangePassOTP').addClass('btn-active');
        } else {
            $('#changePassOTP #btnChangePassOTP').removeClass('btn-active');
        }
    });
    $('#changePassOTP #password_new_confirmation').keyup(function () {
        var password_new = $('#changePassOTP #password_new').val();
        var password_new_confirmation = $('#changePassOTP #password_new_confirmation').val();

        if (password_new.length > 0 && password_new_confirmation.length > 0) {
            $('#changePassOTP #btnChangePassOTP').addClass('btn-active');
        } else {
            $('#changePassOTP #btnChangePassOTP').removeClass('btn-active');
        }
    });
    $('#changePassOTP').on('click', '#btnChangePassOTP', function () {
        var item = $(this);
        var old_curent = item.html();
        item.html('<i class="fa fa-spinner fa-spin"></i> ' + old_curent);
        item.prop('disabled', true);

        var contact_sfid = $('#changePassOTP input[name=contact_sfid]').val();
        var password = $('#changePassOTP input[name=password_new]').val();
        var password_confirmation = $('#changePassOTP input[name=password_new_confirmation]').val();

        if (password.length == 0) {
            $('#changePassOTP .message_error').html('Chưa nhập mật khẩu');
            item.html(old_curent);
            item.prop('disabled', false);
            return false;
        } else if (password_confirmation.length == 0) {
            $('#changePassOTP .message_error').html('Chưa nhập mật khẩu xác thực');
            item.html(old_curent);
            item.prop('disabled', false);
            return false;
        }

        if (password.length < 5) {
            $('#changePassOTP .message_error').html('Mật khẩu phải có ít nhất 5 ký tự');
            item.html(old_curent);
            item.prop('disabled', false);
            return false;
        }

        $.ajax({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            url: '/change-password-otp',
            type: 'POST',
            dataType: 'json',
            data: {
                contact_sfid: contact_sfid,
                password: password,
                password_confirmation: password_confirmation
            },
            success: function (result) {
                item.html(old_curent);
                item.prop('disabled', false);

                if (result.success == true) {
                    $('#changePassOTP input[name=contact_sfid]').val('');
                    $('#changePassOTP input[name=password_new]').val('');
                    $('#changePassOTP input[name=password_new_confirmation]').val('');

                    $('#changePassOTP').removeClass('d-block');
                    $('#changePassOTP').addClass('d-none');

                    $('#changePassOTPSuccess').removeClass('d-none');
                    $('#changePassOTPSuccess').addClass('d-block');
                } else {
                    $('#changePassOTP .message_error').html('Xác nhận mật khẩu không đúng');
                }
            },
            error: function () {
                item.html(old_curent);
                item.prop('disabled', false);
            },
        });
    });

    function countDown(seconds = 60){
        clearInterval(x_countDown);

        $('#confirmOTP #countDownOTP').removeClass('d-none');
        $('#confirmOTP #messageSentAgainOTP').addClass('d-none');

        x_countDown = setInterval(function() {
            seconds -= 1;
            $('#confirmOTP #countDownOTP').find('.seconds').html(seconds);

            if (seconds <= 0) {
                clearInterval(x_countDown);

                $('#confirmOTP #countDownOTP').addClass('d-none');
                $('#confirmOTP #messageSentAgainOTP').removeClass('d-none');
                $('#confirmOTP #countDownOTP').find('.seconds').html('');
            }
        }, 1000);
    }
});
